import { useEffect, useRef } from 'react';
import { mergeProps, useFocusRing, useOption } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './ListBoxItem.module.scss';

const ListBoxItem = ({ item, state }) => {
    const ref = useRef();
    const { optionProps, isSelected, isDisabled } = useOption(
        { key: item.key },
        state,
        ref
    );

    const { isFocused, focusProps } = useFocusRing();

    useEffect(() => {
        if (isFocused && ref?.current?.scrollIntoView) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [isFocused, ref?.current]);

    return (
        <li
            ref={ref}
            {...mergeProps(optionProps, focusProps)}
            data-testid={item?.props['data-testid'] ? item?.props['data-testid'] : null}
            className={[
                styles.container,
                isSelected ? styles.selected : null,
                isDisabled ? styles.disabled : null
            ].join(' ')}
        >
            <div
                className={[styles.content].join(' ')}
            >
                {item.rendered}
            </div>
        </li>
    );
};

ListBoxItem.propTypes = {
    ...defaultAriaProps
};

export default ListBoxItem;
